export default __webpack_public_path__ + "images/39_1_image.jpg";